<template>
	<a
		:href="link"
		target="_self"
		class="article_list_item"
	>
		<div
			class="image"
			:class="{'no-image': !image}"
		>
			<img
				v-if="image"
				v-lazy="image"
				class="lazy"
				:alt="title"
			/>
			<img
				v-else
				v-lazy="sampleImage"
				class="lazy no-image"
				:alt="title"
			/>
		</div>
		<div class="title">
			<h3
				v-if="title"
				v-html="title"
			></h3>
			<!-- <div class="arrow">
				<svg
					width="70"
					height="19"
					viewBox="0 0 70 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M69.669 9.33218L61.3737 0L60.6263 0.664364L67.8865 8.83215H0V9.83215H67.8866L60.6263 18L61.3737 18.6644L69.669 9.33218Z"
					/>
				</svg>
			</div> -->
		</div>

		<p v-if="text">
			<span v-html="text"></span>
			<span class="read_more">Read more...</span>
		</p>
	</a>
</template>

<script>
import SampleImage from '../../images/post_placeholder.png';

export default {
	data() {
		return {
			sampleImage: SampleImage,
		};
	},

	props: {
		image: {
			default: SampleImage,
		},
		title: {},
		text: {},
		link: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.article_list_item {
	display: grid;
	grid-template-rows: auto;
	text-decoration: none;

	@media (max-width: $lg) {
		padding: $spacer $spacer 0;
		margin-bottom: $spacer;
	}

	&:hover {
		cursor: pointer;

		.image {
			img {
				transform: scale(1.1);
				transition: 0.2s ease all;
			}
		}

		// .title {
		// 	.arrow {
		// 		svg {
		// 			left: 30px;
		// 			transition: 0.2s ease all;

		// 			@media (max-width: $lg) {
		// 				left: 0;
		// 			}
		// 		}
		// 	}
		// }
	}

	.image {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		height: 330px;
		overflow: hidden;
		background: var(--cpmec-grey);

		@media (max-width: $lg) {
			height: 223px;
		}

		&.no-image {
			justify-content: center;
			align-items: center;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			margin: 0;
			transition: 0.2s ease all;

			@media (max-width: $lg) {
				max-height: 240px;
			}

			&.no-image {
				width: 150px;
				height: 150px;
				filter: grayscale(1);
				opacity: 0.25;
			}
		}
	}

	.title {
		display: grid;
		grid-template-columns: 1fr;
		column-gap: $spacer * 2;
		margin-top: $spacer;

		@media (max-width: $lg) {
			grid-template-columns: 1fr;
			column-gap: $spacer;
		}

		h3 {
			color: $cpmec-blue;
			margin: 0;
			font-size: 28px;
			line-height: 38px;
			font-family: $font-family;
			font-weight: normal;

			@media (max-width: $lg) {
				font-size: 22px;
				line-height: 32px;
			}
		}

		// .arrow {
		// 	position: relative;
		// 	display: flex;
		// 	flex-direction: row;
		// 	align-items: center;
		// 	margin-top: $spacer / 2;
		// 	width: 70px;
		// 	height: 20px;
		// 	transition: 0.2s ease all;

		// 	svg {
		// 		position: absolute;
		// 		left: 0;
		// 		right: 0;
		// 		transition: 0.2s ease all;

		// 		path {
		// 			fill: $cpmec-blue;
		// 		}
		// 	}
		// }
	}

	p {
		margin: $spacer 0 0;

		span {
			color: $cpmec-grey;
			margin: 0;
			font-size: 20px;

			@media (max-width: $lg) {
				font-size: 18px;
			}

			&.read_more {
				color: $cpmec-blue;
				margin: 0;
				font-size: 20px;
				margin-left: $spacer / 2;

				@media (max-width: $lg) {
					font-size: 18px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ArticleListItem.vue